export default {
  categories: [],
  courses: [],
  featured: [],
  archives: [],
  course: {},
  lessons: [],
  freebies: [],
  lesson: {},
  live: {},
  count: 0,
  archivesCount: 0,
  product: {}
};
